import { render } from "./Space.vue?vue&type=template&id=574f9e59&scoped=true&ts=true"
import script from "./Space.vue?vue&type=script&lang=ts"
export * from "./Space.vue?vue&type=script&lang=ts"

import "./Space.vue?vue&type=style&index=0&id=574f9e59&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574f9e59"]])

export default __exports__